document.getElementById("leftSubMenuToggle").addEventListener("click", function() {
    toggleLeftSubmenu()
})

function toggleLeftSubmenu() {
    var leftMenuWrapper = document.getElementById("leftMenuWrapper");
    var leftMenuToggler = document.getElementById("leftSubMenuToggle");

    leftMenuWrapper.classList.toggle('layout-with-left-column__menu-wrapper__hidden');
    leftMenuToggler.classList.toggle('layout-with-left-column__menu-toggle__not-active');

}